import { GENERICS_HTTP_STATUS_CODES_MAPPER, getDomainNotificationManager } from '@repo/core'
import { takeEvery } from 'redux-saga/effects'
import {
  addTrustDeviceActions,
  changePasswordActions,
  checkUserActions,
  convenienceTestsConfirmActions,
  convenienceTestsDataActions,
  convenienceTestsDraftActions,
  deleteDeviceSigningDataActions,
  deleteDeviceTrustedDataActions,
  devicesDataActions,
  deviceSigningDataActions,
  editUserPreferencesActions,
  mailingAddressRelatedProductsDataActions,
  otpResendActions,
  updateDeviceAliasActions,
  userInfoDataActions,
  userPreferencesDataActions,
} from '../../slices'
import { httpStatusErrorCodesMapper } from './httpStatusErrorCodesMapper'

const { 422: _, ...changePasswordHttpStatusErrorCodesMapper } = GENERICS_HTTP_STATUS_CODES_MAPPER

export function* watchUsersNotifications() {
  yield takeEvery(
    [
      userInfoDataActions.getResponse.type,
      addTrustDeviceActions.postResponse.type,
      deviceSigningDataActions.postResponse.type,
      updateDeviceAliasActions.putResponse.type,
      otpResendActions.postResponse.type,
      editUserPreferencesActions.patchResponse.type,
      userPreferencesDataActions.getResponse.type,
      userPreferencesDataActions.refreshResponse.type,
      deleteDeviceSigningDataActions.deleteResponse.type,
      deleteDeviceTrustedDataActions.deleteResponse.type,
      convenienceTestsDraftActions.putResponse.type,
      convenienceTestsConfirmActions.postResponse.type,
      convenienceTestsDataActions.getResponse.type,
      convenienceTestsDataActions.refreshResponse.type,
      checkUserActions.postResponse.type,
      devicesDataActions.getResponse.type,
      devicesDataActions.refreshResponse.type,
      mailingAddressRelatedProductsDataActions.getResponse.type,
      mailingAddressRelatedProductsDataActions.refreshResponse.type,
    ],
    getDomainNotificationManager({ domain: 'user', httpStatusErrorCodesMapper }),
  )
  yield takeEvery(
    changePasswordActions.postResponse.type,
    getDomainNotificationManager({
      domain: 'user',
      httpStatusErrorCodesMapper: {
        [changePasswordActions.postResponse.type]: changePasswordHttpStatusErrorCodesMapper,
      },
    }),
  )
}
